module.exports = __webpack_public_path__ + "static/media/scoops.graph-w-text.4cc0bc28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sections/LearnOverTime/scoops.graph-w-text.svg
// module id = 76
// module chunks = 0